@if (id) {
  <clp-toolbar [title]="('post.update.title' | translate)"></clp-toolbar>
} @else {
  <clp-toolbar [title]="('post.create.title' | translate)"></clp-toolbar>
}

<div class="px-4 py-3">
  <div class="clp-card">
    <div class="clp-card-body">
      <form class="space-y-4" (ngSubmit)="savePost()" [formGroup]="postForm" novalidate>
        <div>
          <label class="clp-label">{{ 'post.content' | translate }}</label>

          <div class="editor-shell">
            <div class="editor-toolbar">
              <select
                class="editor-select"
                [disabled]="isCodeView"
                [value]="selectedBlockFormat"
                (mousedown)="onToolbarControlMouseDown()"
                (change)="onBlockFormatChange($event)">
                @for (block of blockFormats; track block.value) {
                  <option [value]="block.value">{{ block.label }}</option>
                }
              </select>

              <select
                class="editor-select editor-select-wide"
                [disabled]="isCodeView"
                [value]="selectedFontFamily"
                (mousedown)="onToolbarControlMouseDown()"
                (change)="onFontFamilyChange($event)">
                @for (font of fontFamilies; track font.value) {
                  <option [value]="font.value">{{ font.label }}</option>
                }
              </select>

              <button type="button" class="editor-btn" [disabled]="isCodeView" (mousedown)="onToolbarMouseDown($event)" (click)="applyFormat('undo')" title="Undo"><i class="fa-solid fa-rotate-left"></i></button>
              <button type="button" class="editor-btn" [disabled]="isCodeView" (mousedown)="onToolbarMouseDown($event)" (click)="applyFormat('redo')" title="Redo"><i class="fa-solid fa-rotate-right"></i></button>
              <button type="button" class="editor-btn" [disabled]="isCodeView" (mousedown)="onToolbarMouseDown($event)" (click)="applyFormat('bold')" title="Bold"><i class="fa-solid fa-bold"></i></button>
              <button type="button" class="editor-btn" [disabled]="isCodeView" (mousedown)="onToolbarMouseDown($event)" (click)="applyFormat('italic')" title="Italic"><i class="fa-solid fa-italic"></i></button>
              <button type="button" class="editor-btn" [disabled]="isCodeView" (mousedown)="onToolbarMouseDown($event)" (click)="applyFormat('underline')" title="Underline"><i class="fa-solid fa-underline"></i></button>
              <button type="button" class="editor-btn" [disabled]="isCodeView" (mousedown)="onToolbarMouseDown($event)" (click)="applyFormat('strikeThrough')" title="Strike"><i class="fa-solid fa-strikethrough"></i></button>

              <button type="button" class="editor-btn" [disabled]="isCodeView" (mousedown)="onToolbarMouseDown($event)" (click)="applyFormat('justifyLeft')" title="Align left"><i class="fa-solid fa-align-left"></i></button>
              <button type="button" class="editor-btn" [disabled]="isCodeView" (mousedown)="onToolbarMouseDown($event)" (click)="applyFormat('justifyCenter')" title="Align center"><i class="fa-solid fa-align-center"></i></button>
              <button type="button" class="editor-btn" [disabled]="isCodeView" (mousedown)="onToolbarMouseDown($event)" (click)="applyFormat('justifyRight')" title="Align right"><i class="fa-solid fa-align-right"></i></button>
              <button type="button" class="editor-btn" [disabled]="isCodeView" (mousedown)="onToolbarMouseDown($event)" (click)="applyFormat('justifyFull')" title="Justify"><i class="fa-solid fa-align-justify"></i></button>

              <button type="button" class="editor-btn" [disabled]="isCodeView" (mousedown)="onToolbarMouseDown($event)" (click)="applyFormat('insertUnorderedList')" title="Bulleted list"><i class="fa-solid fa-list-ul"></i></button>
              <button type="button" class="editor-btn" [disabled]="isCodeView" (mousedown)="onToolbarMouseDown($event)" (click)="applyFormat('insertOrderedList')" title="Numbered list"><i class="fa-solid fa-list-ol"></i></button>
              <button type="button" class="editor-btn" [disabled]="isCodeView" (mousedown)="onToolbarMouseDown($event)" (click)="applyFormat('outdent')" title="Outdent"><i class="fa-solid fa-outdent"></i></button>
              <button type="button" class="editor-btn" [disabled]="isCodeView" (mousedown)="onToolbarMouseDown($event)" (click)="applyFormat('indent')" title="Indent"><i class="fa-solid fa-indent"></i></button>

              <button type="button" class="editor-btn" [disabled]="isCodeView" (mousedown)="onToolbarMouseDown($event)" (click)="insertLink()" title="Insert link"><i class="fa-solid fa-link"></i></button>
              <button type="button" class="editor-btn" [disabled]="isCodeView" (mousedown)="onToolbarMouseDown($event)" (click)="removeLink()" title="Remove link"><i class="fa-solid fa-link-slash"></i></button>
              <button type="button" class="editor-btn" [disabled]="isCodeView" (mousedown)="onToolbarMouseDown($event)" (click)="insertHorizontalRule()" title="Horizontal line"><i class="fa-solid fa-minus"></i></button>
              <button type="button" class="editor-btn" [disabled]="isCodeView" (mousedown)="onToolbarMouseDown($event)" (click)="insertTable()" title="Insert table"><i class="fa-solid fa-table"></i></button>
              <button type="button" class="editor-btn" [disabled]="isCodeView" (mousedown)="onToolbarMouseDown($event)" (click)="addTableRow('above')" title="Add row above"><i class="fa-solid fa-arrow-up"></i></button>
              <button type="button" class="editor-btn" [disabled]="isCodeView" (mousedown)="onToolbarMouseDown($event)" (click)="addTableRow('below')" title="Add row below"><i class="fa-solid fa-arrow-down"></i></button>
              <button type="button" class="editor-btn" [disabled]="isCodeView" (mousedown)="onToolbarMouseDown($event)" (click)="removeTableRow()" title="Delete row"><i class="fa-solid fa-trash"></i></button>
              <button type="button" class="editor-btn" [disabled]="isCodeView" (mousedown)="onToolbarMouseDown($event)" (click)="addTableColumn('left')" title="Add column left"><i class="fa-solid fa-left-long"></i></button>
              <button type="button" class="editor-btn" [disabled]="isCodeView" (mousedown)="onToolbarMouseDown($event)" (click)="addTableColumn('right')" title="Add column right"><i class="fa-solid fa-right-long"></i></button>
              <button type="button" class="editor-btn" [disabled]="isCodeView" (mousedown)="onToolbarMouseDown($event)" (click)="removeTableColumn()" title="Delete column"><i class="fa-solid fa-xmark"></i></button>

              <label class="editor-color" title="Text color">
                <input
                  type="color"
                  [disabled]="isCodeView"
                  [value]="selectedTextColor"
                  (mousedown)="onToolbarControlMouseDown()"
                  (change)="onTextColorChange($event)" />
              </label>
              <label class="editor-color" title="Highlight color">
                <input
                  type="color"
                  [disabled]="isCodeView"
                  [value]="selectedBackgroundColor"
                  (mousedown)="onToolbarControlMouseDown()"
                  (change)="onBackgroundColorChange($event)" />
              </label>

              <button type="button" class="editor-btn" [disabled]="isCodeView" (mousedown)="onToolbarMouseDown($event)" (click)="clearFormatting()" title="Clear formatting"><i class="fa-solid fa-eraser"></i></button>
              <button type="button" class="editor-btn" (mousedown)="onToolbarMouseDown($event)" (click)="toggleCodeView()" [class.editor-btn-active]="isCodeView" title="HTML code view">&lt;/&gt;</button>
            </div>

            <textarea
              class="editor-code"
              [class.editor-hidden]="!isCodeView"
              [value]="codeViewContent"
              (input)="onCodeInput($event)">
            </textarea>

            <div
              #editor
              class="editor-content"
              [class.editor-hidden]="isCodeView"
              contenteditable="true"
              [attr.aria-label]="'post.content' | translate"
              (input)="onEditorInput($event)"
              (keyup)="onEditorSelectionChange()"
              (mouseup)="onEditorSelectionChange()"
              (focus)="onEditorSelectionChange()">
            </div>
          </div>

          @if (contentControl?.invalid && contentControl?.touched) {
            <em class="clp-help">{{ 'post.invalidContent' | translate }}</em>
          }
        </div>

        <div class="grid gap-3 md:grid-cols-2">
          <div>
            <label class="clp-label">{{ 'post.videoType' | translate }}</label>
            <select class="clp-select" formControlName="videoType">
              <option [value]="postVideoType.None">{{ 'post.videoTypes.none' | translate }}</option>
              <option [value]="postVideoType.YouTube">{{ 'post.videoTypes.youtube' | translate }}</option>
              <option [value]="postVideoType.Vimeo">{{ 'post.videoTypes.vimeo' | translate }}</option>
            </select>
          </div>

          <div>
            <label class="clp-label">{{ 'post.videoLink' | translate }}</label>
            <input class="clp-input" type="text" formControlName="videoLink" />
          </div>
        </div>

        <div>
          <label class="clp-label">{{ 'post.image' | translate }}</label>
          <input type="file" class="clp-input" accept="image/*" (change)="onImageChange($event)" />

          @if (imagePreview) {
            <div class="mt-2">
              <img class="image-preview" [src]="imagePreview" alt="" />
              <button
                type="button"
                class="mt-2 clp-btn clp-btn-secondary clp-btn-sm"
                (click)="removeImage()">
                {{ 'post.removeImage' | translate }}
              </button>
            </div>
          }
        </div>

        <div>
          <label class="clp-label">{{ 'post.communities' | translate }}</label>
          <div class="max-h-44 overflow-auto rounded-lg border border-slate-700 bg-slate-900/45 p-2">
            @for (community of communities; track community.id ?? $index) {
              <label class="mb-1 flex cursor-pointer items-center gap-2 rounded px-2 py-1 text-sm text-slate-200 hover:bg-slate-800/70">
                <input
                  type="checkbox"
                  [checked]="isCommunitySelected(community.id)"
                  (change)="onCommunitySelectionChange(community.id, $any($event.target).checked)" />
                <span>{{ community.name }}</span>
              </label>
            }
          </div>
          @if (communityIdsControl?.invalid && communityIdsControl?.touched) {
            <em class="clp-help">{{ 'post.invalidCommunities' | translate }}</em>
          }
        </div>

        <div class="flex gap-2">
          <a
            class="clp-btn clp-btn-secondary"
            [routerLink]="['/communityPosts']"
            [queryParams]="(communityId || (postForm.controls.communityIds.value?.[0] ?? null)) ? { communityId: (communityId || (postForm.controls.communityIds.value?.[0] ?? null)) } : null">
            {{ 'general.cancel' | translate }}
          </a>
          <button class="clp-btn clp-btn-warning" type="submit" [disabled]="saving">
            {{ 'general.save' | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
